module.exports = __webpack_public_path__ + "@/assets/img/exchange.9d05c04b.svg";